<template>
  <b-modal id="modalItems" data-backdrop="static" data-keyboard="false" v-model="exibirItens" centered
    :title="$t('Deseja inserir alguma imagem no atendimento') + '?'">
    <!-- <div class="container mt-3 anexoArquivos"> -->
    <h6>KM atual/Horimetro: {{ parseInt(os.km_atual) }}</h6>
    <input type="number" class="form-control" v-model="km_veiculo" placeholder="Insira o KM do veículo:">
    <!-- </div> -->
    <div class="mt-3">
      <h6>{{ $t('Observação') }}:</h6>
      <input v-model="obsExterna" type="text" class="form-control" id="obsItem">
    </div>
    <div class="container mt-3 anexoArquivos">
      <h6>{{$t('Anexo de arquivos')}}:</h6>
      <UploadArquivos></UploadArquivos>
    </div>
    <template #modal-footer>
      <div class="w-100">
        <div class="row center" style="justify-content: center;">
          <b-button class="mr-2" variant="danger" size="lg" @click="$emit('showUploadPecas')">
            {{$t('Cancelar')}}
          </b-button>
          <b-button size="lg" variant="success" @click="validaFinalizar">
            {{$t('Finalizar OS')}}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
import UploadArquivos from '../Modais/UploadArquivos.vue';

export default {
  name: "ModalItems",
  props: {
    os: {}
  },
  data() {
    return {
      selectServico: "",
      obsExterna: "",
      exibirItens: true,
      idConjunto: "",
      nrSeqOs: "",
      km_veiculo: ''
    };
  },

  methods: {
    validaFinalizar() {
      if (this.km_veiculo == 0 || this.km_veiculo < parseInt(this.os.km_atual)) {
        this.$swal.fire({
          title: 'Oops!',
          text: this.$t('Insira um KM maior que o atual'),
          icon: 'error'
        })

        return false
      }

      
      let diferenca = Math.abs(this.os.km_atual - this.km_veiculo);
      console.log(this.os.departamento_os)
      if (this.os.departamento_os == 'ARMAZEM' && diferenca > 744) {
          this.$swal.fire({
              title: 'Oops!',
              text: 'Diferença muito grande entre o KM atual e o informado!',
              icon: 'warning'
          })

          return false
      } 

      // console.log('VAI FINALIZAR')
      const objFinalizacao = {
        km_veiculo: this.km_veiculo, 
        obsExterna: this.obsExterna
      }
 
      this.$emit('finalizarPreventiva', { objFinalizacao })
    }
  },
  created() {
    console.log(this.os)
  },
  components: { UploadArquivos }
}
</script>
<style>
  #modalItems {
    pointer-events: none !important;
  }

  .close {
    display: none !important;
  }

  .anexoArquivos {
    padding: 12px;
    border: 1px solid #e3e3e3;
    border-radius: 14px;
    box-shadow: 0px 0px 6px -4px #000;
  }
</style>